export class GameConstants {

    public static readonly VERSION = "1.0.1";
    public static readonly DEVELOPMENT = false;
    public static readonly SHOW_DEBUG_GRAPHICS = false;
    public static readonly SLOW_MOTION = false;
    public static readonly VERBOSE = true;
    public static readonly DISABLE_FULLSCREEN = true;
    public static readonly GAME_WIDTH = 768;
    public static readonly GAME_HEIGHT = 1024;
    public static readonly PHYS_SCALE = .01;
    public static readonly MAX_STRIKER_SPEED = 2500;
    public static readonly INITIAL_GEMS = 1500;
    public static readonly AVATARS_LENGTH = 2;
    public static readonly FREESTYLE_WINNING_SCORE = 160; 
    public static readonly BEGINNER_MATCH_FEE = 0;
    public static readonly EXPERT_MATCH_FEE = 500;
    public static readonly BEGINNER_MATCH_PRIZE = 25;
    public static readonly EXPERT_MATCH_PRIZE = 750;
    public static readonly MISSED_TURNS_GAME_OVER_FORCED = 3;
    public static readonly STRIKER_TUTORIAL_PX = 15000;
    public static readonly STRIKER_TUTORIAL_SHOT_ANGLE = -87.1 * Math.PI / 180;
    public static readonly SAVED_GAME_DATA_KEY = "gamezop-carrom-king";
}
